const initialState = () => ({
  loading: false,
  visitData: null,
  professionalSignature: null
});

const ACTION_KEY = 'VISIT_DETAIL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_FULL_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_FULL_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULL_FULFILLED`: {
      return {
        ...state,
        loading: false,
        visitData: action.payload
      };
    }
    case `${ACTION_KEY}_SIGNATURE_FULFILLED`: {
      return {
        ...state,
        loading: false,
        professionalSignature: action.payload
      };
    }
    case `${ACTION_KEY}_SIGNATURE_REJECTED`: {
      return {
        ...state,
        professionalSignature: null
      };
    }
    case `${ACTION_KEY}_FULL_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
